<template>
  <el-dialog title="修改密码" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" ref="changeform" :model="changeform" :rules="formRules" :label-width="formLabelWidth">
      <el-form-item label="技师名">
        <el-input v-model="username" disabled placeholder="技师名"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="changeform.password" placeholder="请输入密码" type="password"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirm_password">
        <el-input v-model="changeform.confirm_password" placeholder="请输入确认密码" type="password"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Technician from "@/api/technician.js";
export default {
  data() {
    return {
      username: "",
      changeform: {
        password: "",
        confirm_password: "",
        waiterUserId: ""
      },
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      loading: false,
      dialogVisible: false,
      /*form验证*/
      formRules: {
        password: [
          {
            required: true,
            message: " ",
            trigger: "blur"
          }
        ],
        confirm_password: [
          {
            required: true,
            message: " ",
            trigger: "blur"
          }
        ]
      }
    };
  },
  props: ["open_password", "form"],
  created() {
    this.dialogVisible = this.open_password;
    this.changeform.waiterUserId = this.form.waiterUserId;
    this.username = this.form.username;
  },
  methods: {
    /*添加用户*/
    onSubmit() {
      let self = this;
      if (this.changeform.confirm_password != this.changeform.password) {
        self.$message({
          message: "两次密码不一致",
          type: "error"
        });
        return;
      }

      self.loading = true;
      let params = {};
      params.password = this.changeform.password;
      params.waiterUserId = this.changeform.waiterUserId;
      Technician.changePassword(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，修改成功",
            type: "success"
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/technician/technicianlist/dialog/changepassword.vue